import { IconProps } from 'LibNeo'
import { FieldNames } from 'Constants/FieldNames'
import { ProductModel } from 'Pages/orders'

export type TIconProps = Pick<IconProps, 'name' | 'type'>

export type NavItemType = {
	title: string
	onClick: () => void
	active: boolean
}

export type OrderFormNavigation = {
	title: string
	isView?: boolean
	active?: boolean
	onClick?: (event: React.MouseEvent) => void
	required: FieldNames[]
}

export interface AbstractProduct {
	id: number
	client_type?: ProductModel['client_type']
}

export interface ProductWithRequired {
	product: ProductModel
	required: ProductModel[]
}

export type RelatedProducts = {
	byProductGroup: Set<string>
	byBlocked: Set<number>
}

export enum ProductCardState {
	ADD = 'add',
	CHOOSEN = 'choosen',
	CHANGE = 'change',
	LOCKED = 'locked',
}
